// Generated by scripts/compose-modules.mjs for the plugins in lancerlogin.modules.json. Do not commit; restore with npm run compose:modules -- --restore.
import type { ModuleDefinition } from "../module-platform.ts";
import module_hour_tracking from "../../../../.provision/module-plugins/hour-tracking/src/manifest.ts";
import module_carpool from "../../../../.provision/module-plugins/carpool/src/manifest.ts";
import module_visits from "../../../../.provision/module-plugins/visits/src/manifest.ts";

export const externalModuleManifests: readonly ModuleDefinition[] = [module_hour_tracking, module_carpool, module_visits];
